import React, { useState, memo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ConversationAction, { ConversationActions, ConversationSelectors } from "redux-store/conversation.redux";
import CallingAction from "redux-store/calling.redux";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import {
  Call,
  VideoCall,
  PersonAdd,
  PermMedia,
  Search,
  InsertPhoto,
  GroupRemove,
  Logout,
  RemoveCircle,
  Videocam,
  NotificationsNone,
  ChatOutlined,
  NotificationsOff,
  Notifications,
  SettingsBackupRestore,
} from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import { AppConstant, KeyConstant, LangConstant, SystemConstant } from "const";
import { AvatarGroup, ConfirmDialog, AppDrawer, HandleUploadingInput } from "components";
import Gallery from "../Gallery";
import ButtonGroupInfo from "./ButtonGroupInfo";
import GroupMemberList from "../GroupMemberList";
import PopupGroupMember from "./GroupMember/PopupGroupMember";
import ChooseAdminDrawer from "./GroupMember/ChooseAdminDrawer";
import DialogGroupMember from "./DialogGroupMember";
import GroupMemberRemove from "../GroupMemberList/GroupMemberRemove";
import AddingGroupMembers from "../GroupMemberList/AddingGroupMembers";
import GroupInfoAction, { GroupInfoActions } from "redux-store/group-info.redux";
import { showConfirmLeaveGroup } from "utils/view.utils";
import InitGroupCallPopup from "../MessengerChat/InitGroupCallPopup";
import { isGroupOrChannelType } from "pages/Call";
import DialogConfirmLeave from "../AddingContact/DialogConfirmLeave";
import { useAccount, useBlockedAccountStatus, useMuteGroup } from "hooks";
import { getInteractor } from "services/local.service";
import { getCommonLang, getNSLang } from "utils/lang.utils";
import { AccountActions, AccountSelectors, BranchSelectors } from "redux-store";
import { StorageUtil, toCamel, uuid, convertString2JSON } from "utils";
import { isLoginBranch } from "utils/auth.utils";
import { getBranchOptions, getSavedServer } from "utils/branch.utils";
import { DeleteIcon, VerifiedIcon } from "components/icons";
import { useAlertContext } from "components/context/AlertContext";
import { createSelector } from "reselect";
import { AddingContactButton } from "components/dialog/AddingContactDialog";
import { withDrawerLayout } from "components/hoc";
import GroupSettingNotification from "./GroupSettingNotification";
import SettingMessageDrawer from "./GroupSettingMessage/SettingMessageDrawer";
import { useCallingActions } from "../../../../ring-rtc/state/ducks/calling";
import { mapStateToActiveCallProp, mapStateToIncomingCallProp } from "../../../../ring-rtc/state/smart/CallManager";

const callingUtil = window.electronLibs.ringRtc.callingUtil;
const memoizedReduxState = createSelector(
  [
    BranchSelectors.getSelectedBranch,
    ConversationSelectors.getSelectedGroupId,
    AccountSelectors.getBlockAccountId,
    state => state.callingRedux.isInCall,
    state => state.profileRedux.hasInternet,
    state => state.contactRedux.executeContact,
  ],
  (selectedBranch, selectedGroupId, blockedAccountId, isInCall, hasInternet, executeContact) => {
    return {
      selectedBranch,
      serverOptions: getBranchOptions(selectedBranch?.serverOptions),
      isBranchServer: Boolean(selectedBranch?.type === SystemConstant.SERVER_TYPE.branch),
      selectedGroupId,
      blockedAccountId,
      isInCall,
      hasInternet,
      updateAccountId: executeContact?.contactId,
    };
  },
);

const GroupSettingNotificationDrawer = withDrawerLayout(
  GroupSettingNotification,
  <ButtonGroupInfo
    name={getNSLang(LangConstant.NS_SETTING_NOTIFICATION, "TXT_SETTING_APP_NOTIFICATION")}
    icon={<NotificationsNone />}
  />,
);

const GroupSettingMessageDrawer = withDrawerLayout(
  SettingMessageDrawer,
  <ButtonGroupInfo
    name={getNSLang(LangConstant.NS_HOME_CONVERSATION, "TXT_MESSAGE_SETTING")}
    icon={<ChatOutlined />}
  />,
);

const GroupInfoDrawer = ({ onClose, open, data, isAdminGroup, isInactive }) => {
  const accountId = StorageUtil.getItem(KeyConstant.KEY_ACCOUNT_ID);
  const isPersonal = data.groupType === SystemConstant.GROUP_CHAT_TYPE.personal;
  const isChannelGroup = data.groupType === SystemConstant.GROUP_CHAT_TYPE.channel;
  const personalAccount = isPersonal ? data.groupMembers.find(member => member.id !== accountId) : null;

  const classes = useStyles();
  const dispatch = useDispatch();
  const { t: getLabel } = useTranslation(LangConstant.NS_HOME_CONVERSATION);
  const { currentAccount } = useAccount();
  const { isBlocked, isBlockedAccount } = useBlockedAccountStatus();
  const { showAlert } = useAlertContext();
  const { isMuted, mutePersonalGroup, checkGroupNoticeStt } = useMuteGroup(data.id);
  const {
    selectedBranch,
    serverOptions,
    isBranchServer,
    selectedGroupId,
    blockedAccountId,
    updateAccountId,
    isInCall,
    hasInternet,
  } = useSelector(memoizedReduxState);

  const [isContact, setIsContact] = useState(false);
  const [isOpenGallery, setIsOpenGallery] = useState(false);
  const [isChangeGroupName, setIsChangeGroupName] = useState(false);
  const [isConfirmLeave, setIsConfirmLeave] = useState(false);
  const [isChooseAdmin, setIsChooseAdmin] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [titleGroup, setTitleGroup] = useState();
  const [isOpenAdmin, setIsOpenAdmin] = useState(false);
  const [isConfirmDialog, setIsConfirmDialog] = useState(false);
  const [isRemoveMember, setIsRemoveMember] = useState(false);
  const [isOpenAddMember, setIsOpenAddMember] = useState(false);
  const [isShowInitCall, setIsShowInitCall] = useState(false);
  const [isDisable, setIsDisable] = useState(false);
  const [isDeleteGroup, setIsDeleteGroup] = useState(false);
  const [botDescription, setBotDescription] = useState("");
  const [hiddenF, setHiddenF] = useState();
  const activeCall = useSelector(mapStateToActiveCallProp);
  const incomingCall = useSelector(mapStateToIncomingCallProp);

  const { onOutgoingAudioCallInConversation, onOutgoingVideoCallInConversation } = useCallingActions();

  const onBlockUser = () => {
    let other = data?.groupMembers?.find(s => s.id !== accountId);
    if (other) {
      // TODO: Need to refactor - other should not be undefined/ null
      dispatch(AccountActions.blockUser({ groupId: data.id, blockedAccountId: other.id }));
    }
    onClose();
  };

  const onUnblockUser = () => {
    let other = data?.groupMembers?.find(s => s.id !== accountId);
    if (other) {
      // TODO: Need to refactor - other should not be undefined/ null
      dispatch(AccountActions.unblockUser({ groupId: data.id, blockedAccountId: other.id }));
    }
    onClose();
  };

  const onClickSetAdmin = () => {
    setIsAdmin(true);
    setIsChooseAdmin(false);
    setIsConfirmLeave(false);
  };

  const onChangeGroupName = newGroupName => {
    dispatch(
      GroupInfoAction.updateGroup({
        groupId: selectedGroupId,
        groupName: newGroupName,
        name: JSON.stringify({ name: newGroupName }),
      }),
    );
    setIsChangeGroupName(false);
  };

  const onClickSearchButton = () => {
    dispatch(
      ConversationActions.conversationSet({
        isSearchMode: true,
      }),
    );
    onClose();
  };

  const handleChangeGroupPhoto = files => {
    const file = files[0];
    dispatch(GroupInfoAction.changeGroupPhoto({ file, groupId: data.id }));
  };

  const isAddMemberDrawer = isOpen => () => setIsOpenAddMember(isOpen);

  const handleCall = (callingGroupDetail, isVideoCall) => {
    callingUtil.createCallingInstance();
    callingGroupDetail = toCamel({ ...callingGroupDetail, room_id: uuid() });

    dispatch(
      CallingAction.callingSet({
        callingGroupDetailRing: callingGroupDetail,
      }),
    );

    const prefixKey = StorageUtil.getCurrentPrefixKey();
    const accountId = StorageUtil.getItem(KeyConstant.KEY_ACCOUNT_ID);
    const branchId = StorageUtil.getItem(KeyConstant.KEY_BRANCH_ID, prefixKey);
    const deviceId = StorageUtil.getItem(KeyConstant.KEY_DEVICE_ID, prefixKey);
    if (isVideoCall) {
      onOutgoingVideoCallInConversation(
        callingGroupDetail?.id,
        accountId,
        branchId,
        deviceId,
        callingGroupDetail.roomId,
      );
    } else {
      onOutgoingAudioCallInConversation(
        callingGroupDetail?.id,
        accountId,
        branchId,
        deviceId,
        callingGroupDetail.roomId,
      );
    }
  };

  const createBrowserWindow = () => {
    handleCall(toCamel({ ...data, room_id: uuid() }), false);
  };

  const onCallVideo = () => {
    handleCall(toCamel({ ...data, room_id: uuid() }), true);
  };

  const checkRemoveGroup = () => {
    showConfirmLeaveGroup(data, setIsConfirmLeave, setIsChooseAdmin);
  };

  const onCloseGroupInfo = () => {
    setIsConfirmLeave(false);
    onClose();
  };

  const onClosePopupInitCall = () => {
    setIsShowInitCall(false);
  };

  const onInitCall = () => {
    // const calleeId = isGroupOrChannelType(data.groupType) ? accountId : data.groupMembers[0].id;
    // dispatch(CallingAction.onCallCheck({ accountId: calleeId }));
    setIsShowInitCall(true);
  };

  const onLeave = () => {
    dispatch(
      ConversationAction.sendMessage({
        groupId: data.id,
        sendType: SystemConstant.SEND_TYPE.leaveGroup,
        content: accountId,
        parentId: null,
        deviceList: [],
        branchId: selectedBranch?.id,
        mentionIdsArr: [],
        threadId: null,
        removingId: accountId,
      }),
    );

    setIsConfirmLeave(false);
    onClose();
  };

  const handleGroupInfo = async data => {
    checkGroupNoticeStt();
    const isNotValidCallingPeople = (data.groupMembers || []).length > serverOptions.meetMaxCallPerson;

    setIsDisable(isNotValidCallingPeople);

    if (personalAccount?.id && isPersonal) {
      const accountRecord = personalAccount.id
        ? await getInteractor().LocalAccountService.get(personalAccount.id)
        : null;
      setIsContact(Boolean(accountRecord && accountRecord.isContact));
      personalAccount.name = accountRecord?.name || "Unknown";
      setTitleGroup(personalAccount.name);
      setBotDescription(accountRecord.description);
    } else {
      setIsContact(false);
      setTitleGroup(data.groupName);
    }
  };

  const handleDelete = () => {
    dispatch(
      GroupInfoActions.deleteGroup({
        groupId: data.id,
        all: 1,
        groupType: data.groupType,
      }),
    );
    setIsDeleteGroup(false);
    onClose();
  };

  const handleClickDeleteAll = async () => {
    const lastCallHistory = await getInteractor().LocalCallHistoryService.getLastByGroupId(data.id);
    if (lastCallHistory && lastCallHistory.status === SystemConstant.CALL_HISTORY_STATUS.calling) {
      showAlert({ content: getLabel("TXT_BLOCK_DELETE_GROUP"), alertProps: { severity: "error" } });
    } else {
      setIsDeleteGroup(true);
    }
  };

  const handleNotificationSetting = () => {
    const newState = isMuted ? SystemConstant.STATE.active : SystemConstant.STATE.inactive;
    mutePersonalGroup(newState);
  };

  const onClickResetMark = async () => {
    const resetMark = await getInteractor().LocalSenderKeySharedService.deleteSenderKeySharedByGroupId(selectedGroupId);
    if (resetMark) {
      showAlert({ content: getCommonLang("TXT_RESET_MARK_SUCCESS") });
    } else {
      showAlert({ content: getCommonLang("TXT_RESET_MARK_FAILED"), alertProps: { severity: "error" } });
    }
  };

  useEffect(() => {
    if (false === isLoginBranch(selectedBranch)) return;
    if (data && data.id) {
      handleGroupInfo(data);
    }
    const accountOption = currentAccount?.options ? convertString2JSON(currentAccount?.options) : {};
    setHiddenF(accountOption?.hidden_f || SystemConstant.ACCOUNT_HIDDEN_F.notDisplay);
  }, [data, selectedBranch, currentAccount]);

  useEffect(() => {
    if (blockedAccountId) {
      setIsConfirmDialog(false);
    }
  }, [blockedAccountId]);

  useEffect(() => {
    if (data.id && isPersonal && updateAccountId && personalAccount?.id === updateAccountId) {
      getInteractor()
        .LocalAccountService.get(updateAccountId)
        .then(accountRecord => {
          setIsContact(Boolean(accountRecord && accountRecord.isContact));
          personalAccount.name = accountRecord?.name || "Unknown";
          setTitleGroup(personalAccount.name);
        });
    }
  }, [updateAccountId]);

  const isShowAddingIcon = !isBranchServer && !isContact;
  const isHiddenActions = data.sendToMe || data.isBot;
  const isShowSettingMsgPersonal = isPersonal && false === Boolean(isHiddenActions);
  const isShowSettingMsg = isShowSettingMsgPersonal || isAdminGroup;

  return (
    <AppDrawer open={open} onClose={onClose} anchor="right" hideBackdrop={false}>
      <Box className={classes.boxAvatar}>
        <Box className={classes.chatItemAvatar}>
          <AvatarGroup
            group={{
              groupType: data.groupType,
              groupName: data.groupName,
              privateF: data.privateF,
              isServerLogo: data.isBot,
            }}
            avatarId={data.avatarId}
            BadgeIcon={data.isBot && <VerifiedIcon />}
          />
        </Box>
        <Typography>{titleGroup}</Typography>
      </Box>

      <Box className={classes.boxBtnHeader}>
        <Grid className={classes.gridGroupBtn} container>
          {isGroupOrChannelType(data?.groupType) ? (
            <CustomGrid isPersonal={isPersonal} className={classes.gridBtn} item>
              <IconButton
                className={classes.iconBtn}
                onClick={onInitCall}
                disabled={isDisable || isInCall || !hasInternet || Boolean(activeCall) || Boolean(incomingCall)}
              >
                <Videocam />
              </IconButton>
              <Typography variant="body2">{getLabel(LangConstant.TXT_CONFERENCE_CALL)}</Typography>
            </CustomGrid>
          ) : (
            false === (isBlocked || isHiddenActions) && (
              <>
                {isShowAddingIcon && (
                  <CustomGrid isPersonal={isPersonal} className={classes.gridBtn} item>
                    <AddingContactButton account={personalAccount} />
                  </CustomGrid>
                )}
                <CustomGrid isPersonal={isPersonal} className={classes.gridBtn} item>
                  <IconButton
                    className={classes.iconBtn}
                    onClick={createBrowserWindow}
                    disabled={
                      Boolean(activeCall) ||
                      Boolean(incomingCall) ||
                      isInCall ||
                      !hasInternet ||
                      isInactive ||
                      data.groupMembers.length === 0
                    }
                  >
                    <Call />
                  </IconButton>
                  <Typography variant="body2">{getLabel(LangConstant.TXT_VOICE_CALL)}</Typography>
                </CustomGrid>
                <CustomGrid isPersonal={isPersonal} className={classes.gridBtn} item>
                  <IconButton
                    className={classes.iconBtn}
                    onClick={onCallVideo}
                    disabled={
                      Boolean(activeCall) ||
                      Boolean(incomingCall) ||
                      isInCall ||
                      !hasInternet ||
                      isInactive ||
                      data.groupMembers.length === 0
                    }
                  >
                    <VideoCall />
                  </IconButton>
                  <Typography variant="body2">{getLabel(LangConstant.TXT_VIDEO_CALL)}</Typography>
                </CustomGrid>
              </>
            )
          )}
          {!isPersonal && isAdminGroup && (
            <CustomGrid isPersonal={isPersonal} className={classes.gridBtn} item onClick={isAddMemberDrawer(true)}>
              <IconButton className={classes.iconBtn}>
                <PersonAdd />
              </IconButton>
              <Typography variant="body2">{getLabel(LangConstant.TXT_ADD)}</Typography>
            </CustomGrid>
          )}

          {isPersonal ? (
            <CustomGrid
              isPersonal={isPersonal}
              className={clsx(classes.gridBtn, data.sendToMe && "hidden")}
              item
              onClick={handleNotificationSetting}
            >
              <IconButton className={classes.iconBtn}>{isMuted ? <NotificationsOff /> : <Notifications />}</IconButton>
              <Typography variant="body2">{getCommonLang("TXT_NOTIFICATION")}</Typography>
            </CustomGrid>
          ) : (
            <CustomGrid isPersonal={isPersonal} className={classes.gridBtn} item onClick={onClickSearchButton}>
              <IconButton className={classes.iconBtn}>
                <Search />
              </IconButton>
              <Typography variant="body2">{getLabel("TXT_SEARCH_MESSAGE")}</Typography>
            </CustomGrid>
          )}
          {hiddenF === SystemConstant.ACCOUNT_HIDDEN_F.display && (
            <CustomGrid isPersonal={isPersonal} className={classes.gridBtn} item onClick={() => onClickResetMark()}>
              <IconButton className={classes.iconBtn}>
                <SettingsBackupRestore />
              </IconButton>
              <Typography variant="body2">Reset mark</Typography>
            </CustomGrid>
          )}
        </Grid>
      </Box>
      <Box className={classes.boxGroupInfo}>
        {!isPersonal && (
          <>
            <ButtonGroupInfo
              name={getLabel(isChannelGroup ? "TXT_SEE_CHANNEL_MEMBERS" : "TXT_SEE_GROUP_MEMBERS")}
              onClick={() => setIsOpenAdmin(true)}
            />
            {isAdminGroup && (
              <ButtonGroupInfo
                name={getLabel(isChannelGroup ? "TXT_CHANGE_NAME_CHANNEL" : "TXT_CHANGE_NAME_GROUP")}
                onClick={() => setIsChangeGroupName(true)}
              />
            )}
          </>
        )}

        <Typography className={clsx(classes.typographyGroupInfo, "semiBold-sm-txt")}>
          {getLabel(
            isPersonal
              ? LangConstant.TXT_MORE_ACTIONS
              : isChannelGroup
                ? LangConstant.TXT_CHANNEL_INFO
                : LangConstant.TXT_GROUP_INFO,
          )}
        </Typography>
        <ButtonGroupInfo
          name={getLabel(LangConstant.TXT_GALLERY)}
          icon={<PermMedia className={classes.iconGroupInfoBtn} />}
          onClick={() => setIsOpenGallery(true)}
        />

        {isPersonal ? (
          <ButtonGroupInfo
            name={getLabel("TXT_SEARCH_IN_CONVERSATION")}
            icon={<Search className={classes.iconGroupInfoBtn} />}
            onClick={onClickSearchButton}
          />
        ) : (
          <GroupSettingNotificationDrawer />
        )}

        {isShowSettingMsg && <GroupSettingMessageDrawer />}

        {/* đổi ảnh nhóm */}
        {!isChannelGroup && isAdminGroup && (
          <Box>
            <HandleUploadingInput
              accept={AppConstant.ACCEPTABLE_IMAGE_TYPES}
              className="hidden"
              id="photo_group"
              type="file"
              onChange={handleChangeGroupPhoto}
            />
            <label htmlFor="photo_group">
              <Box className={classes.boxInput}>
                <Typography variant="body1">{getLabel(LangConstant.TXT_CHANGE_GROUP_PHOTO)}</Typography>
                <Box className={classes.boxInsertPhoto}>
                  <InsertPhoto className={classes.iconGroupInfoBtn} />
                </Box>
              </Box>
            </label>
          </Box>
        )}

        <Box className={isHiddenActions && "hidden"}>
          <Typography className={clsx(classes.typographyGroupInfo, "semiBold-sm-txt")}>
            {getLabel(isPersonal ? LangConstant.TXT_PERSONAL_PRIVACY : LangConstant.TXT_PRIVACY)}
          </Typography>
          {isPersonal ? (
            getSavedServer()?.type === SystemConstant.SERVER_TYPE.server && (
              <ButtonGroupInfo
                onClick={() => {
                  isBlockedAccount ? onUnblockUser() : setIsConfirmDialog(true);
                }}
                name={getLabel(isBlockedAccount ? LangConstant.TXT_UN_BLOCK_USER : LangConstant.TXT_BLOCK_USER)}
                icon={<RemoveCircle className={classes.iconGroupInfoBtn} />}
              />
            )
          ) : (
            <>
              <Box className={!isAdminGroup && "hidden"}>
                <ButtonGroupInfo
                  onClick={() => setIsRemoveMember(true)}
                  name={getLabel("TXT_REMOVE_A_MEMBER")}
                  icon={<GroupRemove className={classes.iconGroupInfoBtn} />}
                />
                <ButtonGroupInfo
                  onClick={handleClickDeleteAll}
                  name={getNSLang(
                    LangConstant.NS_HOME_CONVERSATION,
                    data.groupType === SystemConstant.GROUP_CHAT_TYPE.group ? "TXT_DELETE_GROUP" : "TXT_DELETE_CHANNEL",
                  )}
                  icon={<DeleteIcon className={classes.iconGroupInfoBtn} />}
                />
              </Box>
              <ButtonGroupInfo
                onClick={checkRemoveGroup}
                name={isChannelGroup ? getLabel("TXT_LEAVE_CHANNEL_INFO") : getLabel("TXT_LEAVE_GROUP_INFO")}
                icon={<Logout className={classes.iconGroupInfoBtn} />}
              />
            </>
          )}
        </Box>

        {data.isBot && (
          <Box>
            <Typography className={clsx(classes.typographyGroupInfo, "semiBold-sm-txt")}>
              {getLabel("TXT_ACCOUNT_DESCRIPTION")}
            </Typography>
            <Typography p={1.25} textAlign="justify">
              {botDescription}
            </Typography>
          </Box>
        )}
      </Box>

      {isOpenGallery && (
        <Gallery
          open={isOpenGallery}
          groupId={selectedGroupId}
          onClose={() => setIsOpenGallery(false)}
          onCloseAll={onClose}
        />
      )}

      <PopupGroupMember
        open={isChangeGroupName}
        onClose={() => setIsChangeGroupName(false)}
        onSubmit={onChangeGroupName}
        title={
          isChannelGroup ? getLabel(LangConstant.TXT_CHANGE_NAME_CHANNEL) : getLabel(LangConstant.TXT_CHANGE_NAME_GROUP)
        }
        placeholder={
          isChannelGroup
            ? getLabel(LangConstant.TXT_PLACEHODLER_CHANGE_CHANNEL_NAME)
            : getLabel(LangConstant.TXT_CHANGE_GROUP_CHANGE_NAME)
        }
      />

      <DialogConfirmLeave
        open={isConfirmLeave}
        onClose={onCloseGroupInfo}
        title={isChannelGroup ? getLabel("TXT_LEAVE_CHANNEL") : getLabel("TXT_LEAVE_GROUP")}
        content={getLabel("TXT_CONTENT_BUTTON_GROUP")}
        submitProps={{
          submitText: isChannelGroup ? getLabel("TXT_LEAVE_CHANNEL_INFO") : getLabel("TXT_LEAVE_GROUP_INFO"),
          onClick: onLeave,
        }}
        cancelProps={{
          cancelText: getCommonLang("TXT_CANCEL"),
          onClick: onCloseGroupInfo,
        }}
      />

      <DialogGroupMember
        open={isChooseAdmin}
        onClickSetAdmin={onClickSetAdmin}
        groupDetail={data}
        onClose={() => {
          setIsChooseAdmin(false);
        }}
        subTitle={isChannelGroup ? getLabel("TXT_SUBTITLE_LEAVE_CHANNEL") : getLabel("TXT_DES_BUTTON_CONFIRM")}
        confirmButtonText={isChannelGroup ? getLabel("TXT_LEAVE_CHANNEL") : getLabel("TXT_LEAVE_GROUP")}
      />

      <ChooseAdminDrawer
        dataAdmin={data.groupMembers}
        onClose={() => {
          onCloseGroupInfo();
          setIsAdmin(false);
        }}
        open={isAdmin}
        groupId={data.id}
        groupDetail={data}
      />

      {/* Confirm block personal */}
      {isConfirmDialog && (
        <ConfirmDialog
          open
          title={getLabel("TXT_BLOCK_AND_CALL")}
          content={getLabel("FM_CONFIRM_BLOCK_DETAIL", { groupName: titleGroup })}
          submitProps={{
            submitText: getCommonLang("TXT_CONFIRM"),
            onClick: onBlockUser,
            className: classes.submitPropsConfirmDialog,
          }}
          cancelProps={{
            onClick: () => setIsConfirmDialog(false),
            className: classes.cancelPropsConfirmDialog,
          }}
        />
      )}

      {/* Open choose remove member drawer */}
      <GroupMemberRemove
        data={data}
        open={isRemoveMember}
        onClose={() => setIsRemoveMember(false)}
        title={getLabel("TXT_REMOVE_A_MEMBER")}
      />

      <GroupMemberList
        data={data}
        open={isOpenAdmin}
        onClose={() => setIsOpenAdmin(false)}
        onCloseParent={onClose}
        isAdminGroup={isAdminGroup}
      />

      {isOpenAddMember && <AddingGroupMembers groupId={data.id} open={true} onClose={isAddMemberDrawer(false)} />}

      {isShowInitCall && <InitGroupCallPopup open={isShowInitCall} onClose={onClosePopupInitCall} data={data} />}

      {isDeleteGroup && (
        <ConfirmDialog
          open
          title={getLabel(isChannelGroup ? "TXT_DELETE_CHANNEL" : "TXT_DELETE_GROUP")}
          content={getLabel(isChannelGroup ? "TXT_DELETE_CHANNEL_CONFIRM" : "TXT_DELETE_GROUP_CONFIRM")}
          submitProps={{
            submitText: getCommonLang("TXT_CONFIRM"),
            onClick: handleDelete,
          }}
          cancelProps={{ onClick: () => setIsDeleteGroup(false) }}
        />
      )}
    </AppDrawer>
  );
};

GroupInfoDrawer.propTypes = {
  onClose: PropTypes.func,
};

GroupInfoDrawer.defaultProps = {
  onClose: () => {},
};

const CustomGrid = ({ isPersonal, children, ...props }) => (
  <Grid {...props} xs={isPersonal ? 4 : 3}>
    {children}
  </Grid>
);

export default memo(GroupInfoDrawer);

const useStyles = makeStyles(theme => ({
  boxBtnHeader: {
    paddingTop: 10,
    marginBottom: 20,
  },

  boxAvatar: {
    textAlign: "-webkit-center",
    padding: "0px 16px",
  },

  chatItemAvatar: {
    marginBottom: 10,
    width: 50,
    height: 50,
  },

  gridBtn: {
    textAlign: "center",
  },

  gridGroupBtn: {
    padding: "0 10px",
    display: "flex",
    justifyContent: "center",
  },

  boxGroupInfo: {
    padding: "0 7px",
    display: "inline-grid",
    width: "100%",
    marginTop: 10,
  },

  btnGroupInfo: {
    textTransform: "none",
    padding: 10,
    display: "flex",
    justifyContent: "space-between",
    height: 50,
    alignItems: "center",
  },

  typographyGroupInfo: {
    color: theme.palette.text.secondary,
    padding: 10,
  },

  iconBtn: {
    backgroundColor: theme.palette.grey[100],
    marginBottom: 4,
  },

  iconGroupInfoBtn: {
    width: 18,
    height: 18,
  },

  boxInput: {
    cursor: "pointer",
    textTransform: "none",
    padding: 10,
    display: "flex",
    justifyContent: "space-between",
  },

  boxInsertPhoto: {
    width: 36,
    height: 36,
    backgroundColor: "#C4C4C4",
    color: "#010101",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  cancelPropsConfirmDialog: {
    color: theme.palette.grey[200],
    "&:hover": {
      color: theme.palette.grey[500],
    },
  },

  submitPropsConfirmDialog: {
    backgroundColor: theme.palette.secondary.main,
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
      boxShadow: "none",
    },
  },
}));
